import WebsiteLanguageSelect from '@formosa/shared/components/WebsiteLanguageSelect';
import { useTranslation } from '../../i18n/LocaleContext';
import { Link } from 'react-router-dom';

/**
 * 登入／註冊頁右上角：客服、語系切換
 */
export default function AuthHeaderActions() {
  const { locale, t } = useTranslation();
  return (
    <div className="auth-modal__actions">
      <Link
        to="/support"
        className="auth-modal__action-btn"
        aria-label={t('support.title')}
        title={t('support.title')}
      >
        <HeadsetIcon />
      </Link>
      <WebsiteLanguageSelect locale={locale} t={t} />
    </div>
  );
}

function HeadsetIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 13v2a8 8 0 0 0 16 0v-2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M4 13a2 2 0 0 1 2-2h1v6H6a2 2 0 0 1-2-2zm14 0a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M8 19a4 4 0 0 0 8 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
